document.querySelectorAll('.star-rating-box .stars').forEach((container) => {

    //
    const input = container.querySelector('input');

    //create a function to update the filled stars
    const updateFilledStars = (numberOfStarsToFill) => {
        container.querySelectorAll('.star').forEach((star, index) => {
            star.classList.toggle('filled', (index <= numberOfStarsToFill));
        });
    }

    //
    updateFilledStars((parseInt(input.value, 10) - 1));

    //when we leave the container reset the filled stars to the current value
    container.addEventListener('mouseleave', (event)=>{
        updateFilledStars((input.value - 1));
    });

    //add interactions to each star
    for (let i = 0; i < container.querySelectorAll('.star').length; i++) {

        //
        const element = container.querySelectorAll('.star')[i];

        //update the stars so the the "currently hovered" star (and all the siblings on the left) show as fille d- regardless of the true value
        element.addEventListener('mouseenter', () => {
            updateFilledStars(i);
        });

        //update the value of the hidden field
        element.addEventListener('click', () => {
            container.querySelector('input').value = (i + 1);
        });

    }

});